// configService.js

const CONFIG_STORAGE_KEY = 'appConfig'; // Key used in sessionStorage
const STORAGE_EXPIRATION_KEY = 'configExpiration'; // Key to track expiration of config
const EXPIRATION_DURATION_MS = 24 * 60 * 60 * 1000; // Config expires after 24 hours

let appConfig = null;

// Utility function to check if the stored config is expired
const isConfigExpired = () => {
    const expirationTime = sessionStorage.getItem(STORAGE_EXPIRATION_KEY);
    return !expirationTime || new Date().getTime() > parseInt(expirationTime, 10);
};

// Function to fetch configuration from the server
const fetchConfigFromServer = async () => {
    try {
        const response = await fetch('/api/ClientConfig');
        if (!response.ok) {
            console.error('Failed to fetch configuration from server');
            return null;
        }
        const config = await response.json();

        // Store the config in sessionStorage and set an expiration time
        sessionStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config));
        sessionStorage.setItem(STORAGE_EXPIRATION_KEY, (new Date().getTime() + EXPIRATION_DURATION_MS).toString());

        return config;
    } catch (error) {
        console.error('Error fetching configuration:', error);
        return null;
    }
};

// Function to retrieve configuration from sessionStorage or server
export const fetchConfig = async () => {
    // Check if config is already in memory
    if (appConfig) {
        return appConfig;
    }

    // Check if config is available in sessionStorage and not expired
    const storedConfig = sessionStorage.getItem(CONFIG_STORAGE_KEY);
    if (storedConfig && !isConfigExpired()) {
        appConfig = JSON.parse(storedConfig);
        return appConfig;
    }

    // If config is not in sessionStorage or is expired, fetch from server
    appConfig = await fetchConfigFromServer();
    return appConfig;
};

// Getter to access the configuration after it's been fetched
export const getAppConfig = () => appConfig;
